export default __webpack_public_path__ + "static/media/22.807d5d4c.png";